import {course} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from '../../../components/grid-dx/types';

function useDeleteCourse() {
  const deleteCourse = useDelete(course);
  return (deletingOptions: DeletingOptions) => deleteCourse(deletingOptions);
}

export default useDeleteCourse;
